import { Store } from "./reducers/index";
import { DialogState } from "./reducers/modals";
import { Setup } from "../components/setups/SetupsList";
import { Part } from "../components/parts/PartsList";
import { CreateConfigurationResponse } from "../components/configuration/ConfigurationView";
import { Price } from "../components/main/motorcycles/MotorcycleView";
import { SaveDetailsData } from "../components/dialogs/saveConfiguration";

/* SETUPS*/
export const getAllSetups = (store: Store): Setup[] => {
	return store.vehicleOverviewState.Setups;
};

export const getSetupById = (store: Store, setupId: string): Setup => {
	return getAllSetups(store).find(
		(setup: Setup) => setup.Name === setupId
	) as Setup;
};

export const getAppliedSetup = (store: Store) => store.setups.applied;
export const getSelectedSetup = (store: Store) => store.setups.selected;

/* MODALS */
export const getDialogState = (store: Store): DialogState => {
	return store.dialog;
};

/* CONFIGURATION */
export const getPerspective = (store: Store): number => {
	return store.configurationState.perspective;
};

export const getConfiguration = (store: Store): CreateConfigurationResponse => {
	return store.configurationState.configuration;
};
export const getPrice = (store: Store): Price => {
	return store.configurationState.price;
};

export const getImageTimeStamp = (store: Store): number =>
	store.configurationState.imageTimestamp;

export const getPreservedSaveDetailsDataSelector = (
	store: Store
): SaveDetailsData => store.configurationState.preservableSaveDetails;

export const getCategoryScrollPosition = (store: Store): number =>
	store.configurationState.categoryScrollPosition;

export const getConfigurationWasRecentlyCreatedSelector = (store: Store) =>
	store.configurationState.wasRecentlyCreated;

export const getConfigurationIsDirtySelector = (store: Store) =>
	store.configurationState.isDirty;

/* MOTORCYCLES */
export const getMotorcycleModels = (store: Store) => store.modelsResponse;
export const getPriceAvailability = (store: Store) =>
	store.modelsResponse.ShowPricesInConfigurator;
export const getSelectedModel = (store: Store) =>
	store.vehicleOverviewState.Vehicle;
export const getOverview = (store: Store) => store.vehicleOverviewState;

/* CATEGORIES */
export const getCategories = (store: Store) =>
	store.vehicleOverviewState.Categories;

/* PARTS */
export const getSelectedPart = (store: Store) => store.parts.selected as Part;
export const getAllParts = (store: Store) => store.vehicleOverviewState.Parts;
export const getAppliedParts = (store: Store) => store.parts.applied;

/* TOAST */
export const getToastState = (store: Store) => store.toast;

/* CULTURE */
export const getCulture = (store: Store) => store.configurationState.culture;

/* VIEWS */
export const getViews = (store: Store) => store.views;
